/**
 * Constants for Data Processing Component
 * Centralized configuration for timeouts, thresholds, and UI behavior
 */

// Timing constants (in milliseconds)
export const SCROLL_DELAY_MS = 300;
export const AUTO_DISMISS_SUCCESS_MS = 1500;
export const AUTO_DISMISS_ERROR_MS = 5000;
export const DEBOUNCE_DELAY_MS = 300;
export const RETRY_DELAY_MS = 1000;

// Processing thresholds
export const LONG_PROCESSING_THRESHOLD_S = 60;
// NOTE: MAX_FILE_SIZE_MB has been moved to useFileSizeLimit hook for dynamic subscription-based limits
// Use: import { useFileSizeLimit } from '@/hooks/useFileSizeLimit'
export const MIN_DATA_POINTS = 10;
export const MAX_DATA_POINTS = 10000;

// UI constants
export const INITIAL_STEP = 1;
export const TOTAL_WORKFLOW_STEPS = 5;

// Validation limits
export const PARAMETER_LIMITS = {
  EQ_MAX: { min: 0, max: 100, default: 10 },
  EL_MAX: { min: 0, max: 100, default: 10 },
  EL_MIN: { min: -100, max: 0, default: -10 },
  CHG_MAX: { min: 0, max: 100, default: 10 },
  LG_MAX: { min: 0, max: 100, default: 10 },
  GAP_MAX: { min: 0, max: 100, default: 10 }
} as const;

// Animation durations (in milliseconds)
export const ANIMATION_DURATION = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500
} as const;

// Z-index layers
export const Z_INDEX = {
  BASE: 0,
  DROPDOWN: 10,
  MODAL_BACKDROP: 40,
  MODAL: 50,
  NOTIFICATION: 60,
  TOOLTIP: 70
} as const;

// Accessibility
export const ARIA_LIVE_REGIONS = {
  POLITE: 'polite',
  ASSERTIVE: 'assertive',
  OFF: 'off'
} as const;

// Error types for better error handling
export const ERROR_TYPES = {
  NETWORK: 'NETWORK_ERROR',
  VALIDATION: 'VALIDATION_ERROR',
  FILE: 'FILE_ERROR',
  PROCESSING: 'PROCESSING_ERROR',
  PERMISSION: 'PERMISSION_ERROR'
} as const;

export type ErrorType = typeof ERROR_TYPES[keyof typeof ERROR_TYPES];